"use strict";

exports.__esModule = true;
var _exportNames = {
  navigate: true
};
exports.navigate = void 0;

var _routerOriginal = require("@reach/router-original");

Object.keys(_routerOriginal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _routerOriginal[key];
});

var navigate = function navigate(url, options) {
  // when we do not replace the current url or the replacement is just adding a slash we navigate
  // this fixes canonical redirects
  if (!options.replace || window.location.href + '/' === url) {
    window.location = url;
  }
};

exports.navigate = navigate;